// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__u6Rkp","insightsList":"newBusinessInsightsMenu_insightsList__zQOFV","active":"newBusinessInsightsMenu_active__1zMl6"};